module.exports = __webpack_public_path__ + "img/message.e4e57860.svg";